import type { IconData } from '@stacksjs/iconify-core'

export const travelWayfindingPoolLadder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.95 27.43H32v1.52h-3.05Zm-4.57-1.53h4.57v1.53h-4.57Zm0 3.05v1.53h-6.09v-1.53h-4.57v1.53h-6.1v-1.53H3.05v1.53H0V32h32v-1.52h-3.05v-1.53zm-6.09-1.52h6.09v1.52h-6.09Zm0-27.43h4.57v1.52h-4.57Zm-1.53 1.52h1.53v3.05h-1.53ZM13.72 25.9h4.57v1.53h-4.57Zm-6.1 1.53h6.1v1.52h-6.1ZM3.05 0h4.57v1.52H3.05Zm0 25.9h4.57v1.53H3.05Z\"/><path fill=\"currentColor\" d=\"M30.48 22.86h-1.53v-1.53h-4.57V1.52h-1.52v7.62H9.14V1.52H7.62v19.81H3.05v1.53H1.53v1.52H0v1.52h3.05v-1.52h4.57v1.52h6.1v-1.52h4.57v1.52h6.09v-1.52h4.57v1.52H32v-1.52h-1.52Zm-7.62 1.52h-3.05v-1.52h-1.52v-1.53h-4.57v1.53h-1.53v1.52H9.14v-6.1h13.72Zm0-7.62H9.14v-6.09h13.72ZM0 27.43h3.05v1.52H0ZM1.53 1.52h1.52v3.05H1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default travelWayfindingPoolLadder
